module.exports = __webpack_public_path__ + "img/Product-Slider-image.104806d1.png";